import { Icon } from "../Models/Icon";
import approved from "../Images/approved.svg";
import declinedRejected from "../Images/declinedRejected.svg";
import done from "../Images/done.svg";
import inProcess from "../Images/inProcess.svg";
import newImage from "../Images/new.svg";
import pending from "../Images/pending.svg";
import ready from "../Images/ready.svg";
import errorNotFoundOne from "../Images/404error.svg";
import errorNotFoundTwo from "../Images/error404.svg";
import bug from "../Images/bug.svg";

export const defaultImage: Icon = {
  name: "Default",
  url: newImage
};

export const images: Icon[] = [
  {
    name: "Approved",
    url: approved
  },
  {
    name: "DeclinedRejected",
    url: declinedRejected
  },
  {
    name: "Done",
    url: done
  },
  {
    name: "InProcess",
    url: inProcess
  },
  {
    name: "New",
    url: newImage
  },
  {
    name: "Pending",
    url: pending
  },
  {
    name: "Ready",
    url: ready
  },
  {
    name: "Error Not Found 1",
    url: errorNotFoundOne
  },
  {
    name: "Error Not Found 2",
    url: errorNotFoundTwo
  },
  {
    name: "Bug",
    url: bug
  }
];
